import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { tabSyncService } from '@/services/tab-sync-service';
import { appRoutes } from '@/constants/routes';

export const TabSyncProvider = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = tabSyncService.subscribeToLogout(() => {
      navigate(appRoutes.logout, { state: { fromBroadcast: true } });
    });

    return unsubscribe;
  }, [navigate]);

  useEffect(() => {
    // Clean up channel when component unmounts
    return () => {
      tabSyncService.cleanup();
    };
  }, []);

  return <>{children}</>;
};
